import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { walletCurrenciesTypes } from '../../screens/Accounts/constants';
import Accounts from '../../screens/Accounts';
import Details from '../../screens/Accounts/AccountDetails';

const AccountsRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/`}>
        <Redirect to={`${path}/${walletCurrenciesTypes.CRYPTO}`} />
      </Route>
      <Route exact path={`${path}/:walletType`}>
        <Accounts />
      </Route>
      <Route exact path={`${path}/:coin/details`}>
        <Details />
      </Route>
    </Switch>
  );
};

export default AccountsRouter;
